import PocketBase from 'pocketbase';

import { POCKETBASE_URL } from '../config';

const pb = new PocketBase(POCKETBASE_URL);

// Fetch all pilotos de peso records
export async function fetchPilotosPeso() {
    try {
        const records = await pb.collection('egresoCab_Piloto_Peso').getFullList({
            sort: '-fecha',
            fields: 'fecha,nombre,total_peso'
        });
        return records;
    } catch (error) {
        console.error('Error fetching pilotos de peso report:', error);
        throw error;
    }
}

// Save a piloto de peso
export async function savePilotoPeso(pilotoPeso) {
    try {
        if (pilotoPeso.id) {
            // Update existing record
            return await pb.collection('pilotoPeso').update(pilotoPeso.id, pilotoPeso);
        } else {
            // Create new record
            return await pb.collection('pilotoPeso').create(pilotoPeso);
        }
    } catch (error) {
        console.error('Error saving piloto de peso:', error);
        throw error;
    }
}

// Remove a piloto de peso
export async function removePilotoPeso(id) {
    try {
        return await pb.collection('pilotoPeso').delete(id);
    } catch (error) {
        console.error('Error removing piloto de peso:', error);
        throw error;
    }
}

// Search pilotos de peso records
export async function searchPilotosPeso(query) {
    try {
        const records = await pb.collection('egresoCab_Piloto_Peso').getFullList({
            filter: `nombre ~ "${query}"`,
            sort: '-fecha',
            fields: 'fecha,nombre,total_peso'
        });
        return records;
    } catch (error) {
        console.error('Error searching pilotos de peso report:', error);
        throw error;
    }
}

// Subscribe to changes
export function subscribeToPilotosPeso(callback) {
    return pb.collection('egresoCab_Piloto_Peso').subscribe('*', callback);
}

// Unsubscribe from changes
export function unsubscribeFromPilotosPeso(subscription) {
    if (subscription) {
        subscription.unsubscribe();
    }
} 